export default __webpack_public_path__ + "static/media/delhivery3.9a0ce817.gif";